import { withInstall } from '../../../utils/with-install'
import SearchBox from './SearchBox.vue'

export const ElAmapSearchBox = withInstall(SearchBox)
export default ElAmapSearchBox
